import { Paper, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import CloseX from 'common/close-x';
import DocumentTypeImage from 'pages/vault-page/components/document-type-image';

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  file: any;
  // eslint-disable-next-line @typescript-eslint/ban-types
  deleteFileFn?: Function;
};

const useStyles = makeStyles(() => ({
  imageContainer: {
    display: 'inline-block',
    verticalAlign: 'middle',
  },
  paper: {
    padding: '10px',
    cursor: 'pointer',
    verticalAlign: 'middle',
    marginBottom: '15px',
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    display: 'inline-block',
    marginLeft: '15px',
    fontSize: '.8rem',
  },
}));

export default function PublicEstateDocumentPaper({ file, deleteFileFn }: Props) {
  const classes = useStyles();

  return (
    <Paper className={classes.paper}>
      <div className={classes.imageContainer}>
        <DocumentTypeImage fileName={file.name} isFolder={false} small={true} />
      </div>
      <Typography className={classes.title}>{file.name}</Typography>
      <Typography>
        <CloseX
          onClick={() => {
            if (deleteFileFn) {
              deleteFileFn();
            }
          }}
          renderInline={true}
        />
      </Typography>
    </Paper>
  );
}
